import Vue from "vue";
import Vuex from "vuex";

import user  from './modules/user';
import loadBalancer  from './modules/loadBalancer';
import trialUpgradeRequest  from './modules/trialUpgradeRequest';
import simpleStorage  from './modules/simpleStorage';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    loadBalancer,
    trialUpgradeRequest,
    simpleStorage
  },
});
